import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { clearAllState } from 'src/lib/utils';
import { appSelector, setIsInactive } from 'src/store/apps/slices/AppSlice';

const InactiveAccount = () => {
  const { isInactive } = useSelector(appSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOpen = isInactive;

  const handleClose = () => {
    clearAllState();
    navigate('/auth/login');
    dispatch(setIsInactive(false));
  };

  if (!isInactive) return null;

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="inactive-account-modal"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          boxShadow: 24,
          p: 4,
          width: 400,
          borderRadius: 1,
          outline: 'none',
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" component="h2" gutterBottom>
          Account Deactivated
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 , mt: 2}}>
          Your account has been deactivated. Please contact administrator.
        </Typography>
        <Button variant="contained" onClick={handleClose} fullWidth sx={{ mt: 2 }}>
          OK
        </Button>
      </Box>
    </Modal>
  );
};

export default InactiveAccount;
